import styled, { css } from 'styled-components';

export const Wrapper = styled.section<{
  hasBorder?: boolean;
}>`
  ${({ theme, hasBorder }) => css`
    .grid-container.sc-fuel-grid-container-h {
      margin: ${theme.spacing.km0};
      align-items: center;
      padding: ${theme.spacing.km6} ${theme.spacing.km2};
    }

    :hover {
      background-color: #f9f9f9;
      cursor: pointer;
    }

    ${hasBorder &&
    css`
      border-bottom: ${theme.border.style.solid} ${theme.border.width.thinner}
        ${theme.color.border.neutral.default};
    `}
  `}
`;

export const WrapperSubtitleTag = styled.div`
  ${({ theme }) => css`
    padding: 0 ${theme.spacing.km2};
    margin-bottom: ${theme.spacing.km2};
  `}
`;
